import moment from 'moment';
import i18next from "i18next";
import { Tag, Tooltip } from "antd";
import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { MoreMenu } from "datastake-daf/dist/components";

export default function useImpactPriorities() {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState('goodGovernance')

  const filtersConfig = useMemo(() => ({
    language: i18next.language,
    filtersConfig: {},
    onApply: () => { },
    options: {},
    t,
  }), [t, i18next.language]);

  const tabsConfig = useMemo(() => ({
    tabs: [
      { label: t('Good Governance'), value: 'goodGovernance' },
      { label: t('Safe & Dignified Working Conditions'), value: 'safeAndDignifiedWorkingConditions' },
      { label: t('Environmental Protection'), value: 'environmentalProtection' },
    ],
    value: activeTab,
    onChange: (val) => setActiveTab(val),
  }), [t, activeTab]);

  const columns = useMemo(() => [
    {
      dataIndex: 'performanceLevel',
      title: t('Performance Level'),
      width: '30%',
      ellipsis: true,
      render: (v) => <Tooltip title={v}>{v}</Tooltip>,
    },
    {
      dataIndex: 'thematicArea',
      title: t('Thematic Area'),
      width: '30%',
      ellipsis: true,
      render: (v) => <Tooltip title={v}>{v}</Tooltip>,
    },
    {
      dataIndex: 'implementer',
      title: t('Implementer'),
      width: '20%',
      ellipsis: true,
      render: (v) => <Tooltip title={v}>{v}</Tooltip>,
    },
    {
      dataIndex: 'priority',
      title: t('Status'),
      width: 130,
      render: (v, val) => {
        if (val.empty) {
          return <div className="daf-default-cell" />;
        }

        let config = { label: 'Meets', color: 'green' };

        switch (v) {
          case 'low':
            config = { label: 'Low', color: 'blue' };
            break;
          case 'partially-meets':
            config = { label: 'Partially Meets', color: 'orange' };
            break;
          case 'dont-meet':
            config = { label: "Don't Meet", color: 'red' };
            break;
          default:
        }

        return (
          <Tag color={config.color} className="priority-tag" style={{ width: 94 }}>
            {config.label}
          </Tag>
        )
      },
    },
    {
      dataIndex: 'timeline',
      title: t('Timeline'),
      width: 120,
      ellipsis: true,
      render: (date, val) => {
        if (val.empty) {
          return <div className="daf-default-cell" />;
        }

        return moment(date).format('DD MMM YYYY')
      },
    },
    {
      dataIndex: 'accountability',
      title: t('Accountability'),
      ellipsis: true,
      width: '20%',
      render: (v) => <Tooltip title={v}>{v}</Tooltip>,
    },
    {
      dataIndex: 'action',
      title: '',
      width: 80,
      render: (_, val) => {
        if (val.empty) {
          return <div className="daf-default-cell" />;
        }

        const items = [
          { label: 'ESG Analysis', value: 'ESGAnalysis', disabled: true, }
        ];

        return (
          <MoreMenu items={items} />
        )
      }
    },
  ], [t]);

  return { filtersConfig, tabsConfig, columns };
}
